import { useEffect, useMemo, useState } from 'react';
import CreateIcon from '@mui/icons-material/Create';
import Checkbox from '@/trio-ui/Checkbox';
import InputText from '@/trio-ui/InputText';
import Modal from '@/trio-ui/Modal';

type ConfirmationModal = {
  onConfirmClick: (name: string, generateQuestionsByAI?: boolean) => void;
  onCloseClick: () => void;
  defaultName: string;
  isOpen: boolean;
  label: string;
};

export default function ConfirmationModal({
  onConfirmClick,
  onCloseClick,
  defaultName,
  isOpen,
  label,
}: ConfirmationModal): JSX.Element {
  const [interviewName, setInterviewName] = useState(defaultName);
  const [generateQuestionsByAI, setGenerateQuestionsByAI] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setInterviewName(defaultName);
  }, [defaultName]);

  useEffect(() => {
    if (!isOpen) {
      setIsLoading(false);
    }
  }, [isOpen]);

  const isPreScreening = useMemo(() => defaultName.includes('Pre Screening'), [defaultName]);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const {
      target: { value },
    } = event;

    setInterviewName(value);
  };

  const onConfirmHandler = (): void => {
    onConfirmClick(interviewName, generateQuestionsByAI);
    setIsLoading(true);
  };

  const onChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const {
      target: { checked },
    } = event;
    setGenerateQuestionsByAI(checked);
  };

  return (
    <Modal
      modalId="new-topic-name"
      isCentered
      size="sm"
      headerIcon={CreateIcon}
      onConfirmClick={onConfirmHandler}
      modalTitle={label}
      onConfirmLabel="Save"
      isButtonDisabled={!interviewName.length}
      bodyRender={
        <>
          <InputText
            name="interview-name"
            isLabelAboveField
            value={interviewName}
            onChangeHandler={onChangeHandler}
            marginBottom={3}
          />
          {isPreScreening && (
            <Checkbox
              label="Generate questions using AI"
              checked={generateQuestionsByAI}
              name="generate-questions-by-ia"
              onChangeHandler={onChangeCheckbox}
            />
          )}
        </>
      }
      onClose={onCloseClick}
      isOpen={isOpen}
      isLoading={isLoading}
    />
  );
}
